import React from 'react'

import Banner from '../../../Components/Banner';
import { EntSiteCover } from '../../../Components/entretenimiento/EntSiteCover';
import NavBar from '../../../Components/NavBar';

import {ReactComponent as PalokoLogo} from '../../../assets/imgs/entretenimiento/paloko-logo.svg';

import VerButton from '../../../Components/VerButton';
import DarkModeWrapper from '../../../Components/DarkModeWrapper';
import Footer from '../../../Components/Footer';
import { OtherEnts } from '../../../Components/entretenimiento/OtherEnts';

import { MobileMenu } from '../../../Components/MobileMenu';

import '../entretenimiento.css';

import Paloko1 from '../../../assets/imgs/iron-driver/1.jpg';
import Paloko2 from '../../../assets/imgs/iron-driver/2.jpg';
import Paloko3 from '../../../assets/imgs/iron-driver/3.jpg';
import Paloko4 from '../../../assets/imgs/iron-driver/4.jpg';
import Paloko5 from '../../../assets/imgs/iron-driver/6.jpg';
import Paloko6 from '../../../assets/imgs/iron-driver/5.jpg';

import Logo from '../../../assets/imgs/iron-driver/logo.png';

function IronDriver() {

    const bold = {fontWeight: 600};

    return (
        <>
        <MobileMenu/>
        <div className='centering-wrapper' style={{backgroundColor: '#000000'}}>
            <div className='max-width-container'>
                
                <NavBar/>
                <EntSiteCover>
                    <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center'}}>
                        <img src={Logo} style={{ maxWidth: '90%', height: 'auto'}}/>
                    </div>
                </EntSiteCover>
            </div>
        </div>
        <div className='centering-wrapper'>
            <div className='max-width-container'>
                <div className='ent-site-body-wrapper'>
                    <div className='ent-site-header-wrapper'>
                        <div className='ent-site-title'>
                        14 simuladores deportivos de alta gama
                        </div>
                        <div className='ent-site-description'>
                            Ahora podes sentir la adrenalina de correr a 300km/h en nuestros simuladores con cientos de pistas para explorar.
                        </div>
                    </div>
                    {/*make it a component?*/}
                    <div className='ent-site-card-grid-wrapper'>
                        <div className='ent-col-1'>
                            <img style={{all: 'inherit'}} src={Paloko1} alt=""/>
                        </div>
                        <div className='ent-col-2'>
                            <div className='ent-col-2-row-1 square-radius'>
                                <img className='mosaic-image' src={Paloko2} alt=""/>
                            </div>
                            <div className='ent-col-2-row-2 square-radius'>
                                <img src={Paloko3} alt="" style={{all: 'inherit'}}/>
                            </div> 
                        </div>
                        <div className='ent-col-3'>
                            <div className='ent-col-3-row-1'>
                                <div className='ent-col-3-row-1-col-1 square-radius'>
                                    <img src={Paloko4} alt="" style={{all: 'inherit'}}/>
                                </div>
                                <div className='ent-col-3-row-1-col-2 square-radius'>
                                    <img src={Paloko5} alt="" style={{all: 'inherit'}}/>
                                </div>
                            </div>
                            <div className='ent-col-3-row-2 square-radius'>
                                <img src={Paloko6} alt="" style={{all: 'inherit'}}/>
                            </div>
                        </div>
                    </div>
                    {/*/component*/}
                    
                    <div className='call-to-events-wrapper'>
                        <div className='call-to-events-title'>
                            ¿Queres reservar tu lugar?
                        </div>
                        <VerButton link={'https://wa.me/+5491127278203?text=Hola%2C%20vengo%20de%20la%20web%20y%20queria%20contactarte%20para...'} newtab={true}>Contactanos</VerButton>
                    </div>


                </div>
            </div>
        </div>
        <div className='centering-wrapper' style={{backgroundColor: '#F0F0F0', marginBottom: '-20px'}}>
            <div className='max-width-container'>
                <OtherEnts inPaloko={true}/>
            </div>
        </div>
        <DarkModeWrapper>
            <Footer entSite={true}/>
        </DarkModeWrapper>

        </>
    )
}

export default IronDriver;
